// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pai-","field":"styles_field__13B6T","fieldCol":"styles_fieldCol__2HM-X","diffCol":"styles_diffCol__1xd5t","diff":"styles_diff__VSCT3"};